import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import Cursor from "@/components/Cursor";
import DraftingGrid from "@/components/DraftingGrid";
import Navigation from "@/components/Navigation";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import { useLenis } from "@/hooks/useSmoothScroll";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <Cursor />
        <DraftingGrid />
        <Navigation />
        <AnimatedRoutes />
        <Toaster position="bottom-right" theme="light" />
      </BrowserRouter>
    </div>
  );
}

export default App;
